<template lang="pug">
.pa-4
  v-card.elevation-1.mb-4.pr-4
    .d-flex.ai-center
      .flex-1
        v-card-title.pa-2.pl-4.font-size-16
          span.font-weight-700 KPI por tipo de ticket
        v-card-subtitle.pb-3.font-size-12.grey--text Seleccione un tipo de ticket valido
      .d-flex
        v-select(v-model='tipoTicket' solo :items="tipos"   item-text="label" item-value="value"  label='Tipo'  dense hide-details @change="changeTipo()")
  card-tickets-por-meses.mb-6(v-if="isReadyCharts" :tipo="tipoTicket" :tipo-area="tipoTicket === 'garantia' ? 'taller' : ''")
  card-tickets-pendientes-por-asesor.mb-6(v-if="isReadyCharts" :tipo="tipoTicket" :tipo-area="tipoTicket === 'garantia' ? 'taller' : ''")
  card-tickets-por-estado.mb-6(v-if="isReadyCharts" :tipo="tipoTicket" :tipo-area="tipoTicket === 'garantia' ? 'taller' : ''")
  card-tickets-cerrados-horas.mb-6(v-if="isReadyCharts" :tipo="tipoTicket" :tipo-area="tipoTicket === 'garantia' ? 'taller' : ''")
  card-tickets-recall.mb-6(v-if="isReadyCharts && tipoTicket !== 'solicitud de insumo'" :tipo="tipoTicket" :tipo-area="tipoTicket === 'garantia' ? 'taller' : ''")
</template>

<script>
import Router from '../router/dispatcher.js'
import cardLineChartCountTicketsPorEstados from '@/components/c_card_chart_line_cantidad_total_tickets_por_estados'
import cardLineChartCountTicketsPorMeses from '@/components/c_card_chart_pie_cantidad_total_tickets_por_meses'
import cardChartLineChartRecall from '@/components/c_card_chart_bar_tickets_en_recall'
import cardChartLineChartTicketsCerradoHoras from '@/components/c_card_chart_line_tickets_cerrados_por_horas_activo'
import cardChartLineChartTicketsPendientesPorAsesor from '@/components/c_card_chart_bar_tickets_pendientes_por_asesor'
export default {
  name: 'View_welcome_dispatcher',
  components : {
    'card-tickets-recall'       : cardChartLineChartRecall,
    'card-tickets-por-estado'       : cardLineChartCountTicketsPorEstados,
    'card-tickets-por-meses'       : cardLineChartCountTicketsPorMeses,
    'card-tickets-cerrados-horas': cardChartLineChartTicketsCerradoHoras,
    'card-tickets-pendientes-por-asesor': cardChartLineChartTicketsPendientesPorAsesor
  },
  data () {
    return {
      reveal             : false,
      ticketsRecall      : false,
      empresa            : process.env.EMPRESA,
      empresa_full       : process.env.EMPRESA_FULL,
      nombre             : localStorage.getItem('nombre'),
      tipoTicket : 'garantia',
      isReadyCharts : true,
      tipos : [
        {
          value: 'garantia',
          label : 'Garantia'
        },
        {
          value: 'incidencia con equipo',
          label : 'Incidencia con equipo - Contrato'
        },
        {
          value: 'solicitud de insumo',
          label : 'Solicitud de insumo - Contrato'
        }
      ]
    }
  },
  computed : {
    abiertos () {
      var vm = this
      return vm.$store.state.ticket.abiertos
    }
  },
  methods: {
    goTo (page) {
      Router.push(page)
    },
    changeTipo () {
      var vm = this
      vm.isReadyCharts = false
      vm.$nextTick(() => {
        vm.isReadyCharts = true
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.full-screen-kpi
  position  : absolute;
  top       : 117px;
  left      : 18px;
  width     : 97%;
  // height    : 95vh;
  z-index   : 1000;
  // min-height: 80vh;
</style>




// WEBPACK FOOTER //
// View_welcome_dispatcher.vue?31f3b94a